import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fields" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Rename person')), 1)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_component_NcButton, {
            class: "button",
            variant: "primary",
            disabled: !_ctx.canSave,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', 'Update')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_NcTextField, {
              class: "field",
              autofocus: true,
              modelValue: _ctx.rawInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rawInput) = $event)),
              label: _ctx.t('memories', 'Name'),
              "label-visible": false,
              placeholder: _ctx.t('memories', 'Name'),
              onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.save()), ["enter"]))
            }, null, 8, ["modelValue", "label", "placeholder"])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}